<template>
    <span>
        <SubmittedIcon
            v-if="forecastWindow && forecastWindow.status === FORECAST_WINDOW_STATUS.SUBMITTED && !forecastWindow.isValidated"
            class="zone-icon"
        />
        <CheckMarkIcon v-else-if="forecastWindow && forecastWindow.isValidated" class="zone-icon" />
        <ReChallengeIcon v-else-if="forecastWindow && forecastWindow.status === FORECAST_WINDOW_STATUS.RE_CHALLENGED" class="zone-icon" />
        <CheckMarkIcon v-else style="visibility: hidden" class="zone-icon" />
    </span>
</template>
<script>
import CheckMarkIcon from "@/components/forecasts/elements/icons/CheckMarkIcon";
import ReChallengeIcon from "@/components/forecasts/elements/icons/ReChallengeIcon";
import { FORECAST_WINDOW_STATUS } from "@/components/forecasts/constants";
import SubmittedIcon from "./icons/SubmittedIcon";

export default {
    components: {
        SubmittedIcon,
        CheckMarkIcon,
        ReChallengeIcon
    },
    props: {
        forecastWindow: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            FORECAST_WINDOW_STATUS
        };
    }
};
</script>
<style scoped lang="scss">
.zone-icon {
    width: 15px;
    height: 15px;
    margin-right: 3px;
}
</style>



// WEBPACK FOOTER //
// ZoneStatus.vue?c2ee8a92